document.addEventListener("DOMContentLoaded", function () {
  $(".image-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next"><svg
      role="img"
      aria-labelledby="icon-right-arrow-title-{{ index | default: "0" }}"
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="icon-right-arrow-title-{{ index | default: "0" }}">Next</title>
      <path d="M1 1L6 6.5L1 12" stroke="currentColor" fill="none"/>
    </svg></button>`,
    prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous"><svg
      role="img"
      aria-label="left-arrow"
      aria-labelledby="icon-left-arrow-title-{{ index | default: "0" }}"
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="icon-left-arrow-title-{{ index | default: "0" }}">Prev</title>
      <path d="M6 1L1 6.5L6 12" stroke="currentColor" fill="none"/>
    </svg></button>`,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
